import { route, tag, type PageTour } from '../pageTour';

export const systemAlertsTour: PageTour = {
  id: 'page-system-alerts',
  version: 2,
  title: 'System Alerts',
  summary: 'Problems with the system itself: sites offline, CPU / memory / disk, failing services.',
  match: route('/system-alerts'),
  steps: [
    {
      target: tag('system-alerts-tabs'),
      title: 'Sections',
      description:
        'System alerts shows sites going offline and CPU / memory / disk alerts, System errors shows failing services. When and to whom they are sent is set on the Alert Config page.',
      side: 'bottom',
    },
    {
      target: tag('system-alerts-filters'),
      title: 'Filter',
      description: 'Show only active or resolved alerts, and narrow them by severity.',
      side: 'right',
    },
    {
      target: tag('system-alerts-events'),
      title: 'Alert events',
      description:
        'Each alert with its site and when it started. Acknowledge, assign or resolve it from its row, or click it for details.',
      side: 'top',
    },
    {
      target: tag('system-alerts-refresh'),
      title: 'Refresh',
      description: 'Reload alerts, errors and rules to see the latest state. The badges beside it count active critical and warning alerts.',
      side: 'bottom',
    },
  ],
};
